/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_View_PageInputs */

const en_mobile_view_page = /** @type {(inputs: Mobile_View_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Page`)
};

const es_mobile_view_page = /** @type {(inputs: Mobile_View_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver página`)
};

/**
* | output |
* | --- |
* | "View Page" |
*
* @param {Mobile_View_PageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_view_page = /** @type {((inputs?: Mobile_View_PageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_View_PageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_view_page(inputs)
	return en_mobile_view_page(inputs)
});